import { useEffect, useState } from "react";
import { Layout } from "../components/Layout";
import { api } from "../lib/api";
import { cn } from "../lib/utils";
import { AlertTriangle } from "lucide-react";

export default function CorporateBuyers() {
  const [buyers, setBuyers] = useState([]);
  useEffect(() => { api.get("/corporate/buyer-scorecard").then((r) => setBuyers(r.data)); }, []);

  return (
    <Layout variant="corporate">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Corporate</div>
        <h1 className="text-3xl font-bold text-navy">Buyers</h1>
        <p className="text-sm text-slate-500 mt-1 font-medium">Full roster with 90-day performance trends and override audit.</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm" data-testid="buyers-table">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="text-[10px] uppercase tracking-wider text-slate-600">
              <th className="text-left px-4 py-3 font-bold">Buyer</th>
              <th className="text-left px-4 py-3 font-bold">Rooftop</th>
              <th className="text-right px-4 py-3 font-bold">Units 90d</th>
              <th className="text-right px-4 py-3 font-bold">Avg gross</th>
              <th className="text-right px-4 py-3 font-bold">Hit rate</th>
              <th className="text-right px-4 py-3 font-bold">Override</th>
              <th className="text-right px-4 py-3 font-bold">CTM</th>
              <th className="text-center px-4 py-3 font-bold">Flag</th>
            </tr>
          </thead>
          <tbody>
            {buyers.map((b) => {
              const flagged = b.override_rate > 25 || b.strong_buy_hit_rate < 65;
              return (
                <tr key={b.buyer_id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-3 font-semibold text-navy">{b.buyer_name}</td>
                  <td className="px-4 py-3 text-xs text-slate-600">{b.rooftop_name?.replace("Ourisman ", "")}</td>
                  <td className="px-4 py-3 text-right tabular font-semibold">{b.units}</td>
                  <td className="px-4 py-3 text-right tabular font-bold">${b.avg_gross.toLocaleString()}</td>
                  <td className={cn("px-4 py-3 text-right tabular font-semibold",
                    b.strong_buy_hit_rate >= 75 ? "text-verdict-strongText" : b.strong_buy_hit_rate >= 65 ? "text-slate-700" : "text-verdict-passText")}>
                    {b.strong_buy_hit_rate}%
                  </td>
                  <td className={cn("px-4 py-3 text-right tabular font-semibold",
                    b.override_rate <= 15 ? "text-verdict-strongText" : b.override_rate <= 25 ? "text-verdict-conditionalText" : "text-verdict-passText")}>
                    {b.override_rate}%
                  </td>
                  <td className="px-4 py-3 text-right tabular font-semibold">{b.cost_to_market}%</td>
                  <td className="px-4 py-3 text-center">
                    {flagged && (
                      <span className="inline-flex items-center gap-1 text-freddy-red font-bold">
                        <AlertTriangle size={12} />
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
